<div class="card carddborder">
  <div class="card-header">
    <div class="launch-header d-flex w-100 justify-content-between">
      <div class="launch-header">
        <button class="btn btn-light" (click)="back()"><i class="fa fa-angle-left"></i> EKS Dashboard</button>
        <h5 class="mb-0">Node Group Dashboard</h5>
      </div>
      <div class="dashboard-header-actions">
        <button type="button" class="btn request-eks-btn" (click)="openNodeGroupModal()">
          <span class="request-eks-btn__plus">+</span>
          Add Node Group
        </button>
        <button class="btn btn-light" [disabled]="loading" (click)="refresh()">
          {{ loading ? "Loading..." : "Refresh" }}
        </button>
      </div>
    </div>
  </div>

  <div class="card-body">
    <div class="eks-request-context mb-3">
      <div class="eks-request-context-chip">
        <span>Cluster</span>
        <strong>{{ clusterName || "-" }}</strong>
      </div>
      <div class="eks-request-context-chip">
        <span>Account</span>
        <strong>{{ accountId || "-" }}</strong>
      </div>
      <div class="eks-request-context-chip">
        <span>Region</span>
        <strong>{{ region || "-" }}</strong>
      </div>
    </div>

    <div class="mapping-box nodegroup-table-box">
      <div class="mapping-title">Node Group Requests</div>
      <div *ngIf="loading && rows.length===0" class="text-muted">Loading node group requests...</div>
      <div *ngIf="!loading && error" class="alert alert-danger mb-3">{{ error }}</div>

      <table *ngIf="!error" class="table table-sm mb-0 ec2-dashboard-table nodegroup-dashboard-table nodegroup-requests-table">
        <thead>
          <tr>
            <th class="col-sno">S No</th>
            <th class="col-nodegroup-name">Node Group Name</th>
            <th class="col-requested-by">Requested By</th>
            <th class="col-stage">Stage</th>
            <th class="col-status">Status</th>
            <th class="col-nodegroup-instances">Instance Types</th>
            <th class="col-nodegroup-desired">Desired</th>
            <th class="col-result">Failed Reason</th>
            <th class="col-actions text-center"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of rows; let i = index">
            <td class="col-sno">{{ i + 1 }}</td>
            <td class="col-nodegroup-name">{{ row.nodegroup_name || "-" }}</td>
            <td class="col-requested-by">{{ row.requested_by || "-" }}</td>
            <td class="col-stage">{{ row.stage || "-" }}</td>
            <td class="col-status">{{ row.status || "-" }}</td>
            <td class="col-nodegroup-instances">{{ row.instance_types?.join(", ") || "-" }}</td>
            <td class="col-nodegroup-desired">{{ row.desired_count ?? "-" }}</td>
            <td class="col-result">{{ row.reason || "-" }}</td>
            <td class="col-actions">
              <div class="action-group">
                <a
                  class="btn btn-sm btn-outline-primary details-btn"
                  [routerLink]="['/dash/operations/eks-nodegroup-request', row.request_id]"
                  [queryParams]="detailQueryParams(row)"
                >
                  Details
                </a>
              </div>
            </td>
          </tr>
          <tr *ngIf="rows.length === 0 && !loading">
            <td colspan="9" class="text-center text-muted">No node group requests found.</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="step-footer mt-2" *ngIf="hasMore">
      <button class="btn btn-light" [disabled]="loading" (click)="loadRequests(false)">
        {{ loading ? "Loading..." : "Load More" }}
      </button>
    </div>
  </div>
</div>

<app-nodegroup-modal
  [visible]="showNodeGroupModal"
  [nodeGroupContext]="nodeGroupContext"
  [accountId]="accountId"
  [region]="region"
  [apiBaseUrl]="apiBaseUrl"
  [urlPrefix]="urlPrefix"
  (close)="closeNodeGroupModal()"
  (created)="onNodeGroupCreated()"
></app-nodegroup-modal>
